(function ($) {

    $(document).ready(function () {
        $("body").delegate("a.scroll_to[href*='#']", "click", function(e) {
            e.preventDefault();
            let id = $(this).attr("href"),
                top = $(id).offset().top,
                header_height = $("header.header").outerHeight( true );
            $("body, html").animate({scrollTop: top - header_height}, 1000);
        });
        $(".widget .menu .title").on("click", function () {
            if($(this).hasClass('open')) {
                $(this).next().slideUp("slow");
                $(this).removeClass('open');
            } else {
                $(this).next().slideDown("slow");
                $(this).addClass('open');
            }
        });
        $(".read-more-link a").on("click", function () {
            if($(this).hasClass("show-more")) {
                $(this).hide();
                $(this).next().show();
                $(this).closest(".text").find(".content").addClass("open");
            } else {
                $(this).hide();
                $(this).prev().show();
                $(this).closest(".text").find(".content").removeClass("open");
            }
        });
        $(".section_block_type_3 .columns .content .title, .section_block_type_4 .columns .content .title").on("click", function () {
            let ww = $(window).width();
            if(ww < 768) {
                if($(this).hasClass('open')) {
                    $(this).next().slideUp("slow");
                    $(this).removeClass('open');
                } else {
                    $(this).next().slideDown("slow");
                    $(this).addClass('open');
                }
            }
        });
        $(".section_subpage_slider .slick-slider").slick({
            infinite: true,
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            speed: 500,
            cssEase: "linear",
            mobileFirst: true,
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                }

            ]
        });
        $(".section_image_gallery:not(.-simple) .slick-slider").slick({
            infinite: true,
            dots: false,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            speed: 500,
            cssEase: "linear",
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }

            ]
        });
        $(".section_image_gallery.-simple .slick-slider").slick({
            infinite: true,
            dots: false,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            speed: 500,
            cssEase: "linear",
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }

            ]
        });

    });

})(jQuery);